module.exports = __webpack_public_path__ + "img/Superb_sword_14.999dd3cf.png";